import React, { Component } from "react";
import { Spin } from "antd";
import "antd/dist/antd.css";
import styles from "./styles.scss";
import WBtn from "../../components/WBtn/WBtn";
import CONFIG from "../../config";
import http from "../../helpers/http";
import WJSON from "../../helpers/json";
import WFirebase from "../../helpers/firebase";
import UserInfo from "../../helpers/userinfo";
import DatePicker from "react-datepicker";
import moment from "moment";
import "moment/locale/zh-tw";
import qs from "query-string";
import WSpinner from "../../components/WSpinner/WSpinner";
import WMask from "../../components/WMask/WMask";
import WModal from "../../components/WModal/WModal";
import "react-datepicker/dist/react-datepicker.css";
import _ from "lodash";

moment.locale("zh-tw");
class Booking extends Component {
  constructor(props) {
    super(props);

    let item = {
      pu_id: "---",
      name: "---",
      booking_today: false,
      point: "1",
      cleaning_point: "0點",
      desc: "",
      pic: null,
      pics: [],
    };

    let query = qs.parse(props.location.search);

    if (query.item) {
      item = WJSON.decode(query.item);
    }
    /**
     * booking_today :true 可以當日預約
     */
    let canBookingToday = _.get(item, "booking_today", false) === true;
    this.state = {
      item: item,
      date: moment()
        .add(canBookingToday === true ? 0 : 1, "day")
        .format("YYYYMMDD"), //selected date
      available_time: [],
      available_time_message: null,
      show_spinner: false,
      message: null,
      remain: 1, //預約上限
      form: {
        pu_id: item.pu_id,
        date: moment().format("YYYYMMDD"), //今天
        period: "",
        service_week: "",
        jange: "",
        person_count: "1",
        user_name: "",
        remark: "",
        tel: "",
        clear_cost: item.cleaning_point,
      },
    };
  }

  componentDidMount() {
    /* 判斷是否可以當日預約 */
    this.changeDate(
      moment()
        .add(this.canBookingToday() ? 0 : 1, "day")
        .format("YYYYMMDD")
    );

    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }
  canBookingToday() {
    return _.get(this, "state.item.booking_today", false) === true;
  }
  changeDate(dateString = moment.format("YYYYMMDD")) {
    console.log("gg", dateString);
    const form = this.state.form;

    form.period = null;

    this.setState({
      form,
      date: dateString,
      available_time_message: "讀取中",
      available_time: [],
    });

    // let date = moment.format("YYYYMMDD")
    this.setState({ isFetchBookingTime: true });
    http.post(
      CONFIG.API_HOST + "api/v1.7/booking/time",
      {
        pu_id: this.state.item.pu_id,
        date: dateString,
      },
      (state, res) => {
        this.setState({
          isFetchBookingTime: false,
          available_time_message: null,
        });

        const { code = 100, reason = "發生錯誤", data = {} } = res;

        if (state === false) {
          return this.setState({ available_time_message: "發生錯誤" });
        }

        if (code !== 200) {
          return this.setState({ available_time_message: reason });
        }

        const { available_time = [], user = {} } = data;

        const { form = {} } = this.state;

        var self = this;

        this.setState({
          available_days: _.get(res, "data.available_days"),
        });

        if (res.data && res.data.available_time) {
          form.user_name = user.name;
          form.tel = user.mobile;

          this.setState(
            {
              available_time: available_time,
              available_time_message:
                available_time.length === 0 ? "目前無可預約時段" : null,
              form: form,
            },
            function () {
              self.changeTime();
            }
          );
        }
      }
    );
  }

  changeTime(event) {
    const _val = event ? event.target.value : 0;

    const { available_time, form } = this.state;

    if (!available_time || available_time.length <= _val) {
      return console.error("item不存在");
    }

    let time_item = available_time[_val];

    form.date = time_item.select_date;

    form.period = time_item.period ? time_item.period : time_item.period0;

    form.service_week = time_item.service_week;

    form.jange = time_item.jange;

    this.setState({ form: form, remain: time_item.remain });
  }

  handleFormChange(evt) {
    var form = this.state.form;
    form[evt.target.name] = evt.target.value;
    this.setState({ form: form });
  }

  submit() {
    var form = this.state.form;
    this.setState({
      error_period: !form.period || 0 === form.period.length,
      error_person_count: !form.person_count || 0 === form.person_count.length,
      error_tel: !form.tel || 0 === form.tel.length,
      error_user_name: !form.user_name || 0 === form.user_name.length,
    });

    if (!form.date || 0 === form.date.length) {
      return WModal.show("請選擇預約日期");
    }

    if (!form.period || 0 === form.period.length) {
      return WModal.show("請選擇預約時段");
    }

    if (!form.person_count || 0 === form.person_count.length) {
      return WModal.show("請輸入預約人數");
    }

    if (!form.tel || 0 === form.tel.length) {
      return WModal.show("請輸入聯絡電話");
    }

    if (form.tel.length >= 20) {
      return WModal.show("電話號碼不正確");
    }

    if (!form.user_name || 0 === form.user_name.length) {
      return WModal.show("請輸入住戶姓名");
    }

    if (form.user_name && form.user_name.length >= 20) {
      return WModal.show("姓名長度限20個字");
    }

    if (parseInt(form.person_count, 10) > this.state.remain) {
      return WModal.show("預約人數超過上限");
    }

    if (form.remark && form.remark.length > 50) {
      return WModal.show("備註內容限50個字");
    }

    this.setState({ show_spinner: true, message: null });

    http.post(CONFIG.API_HOST + "api/v1.7/booking", form, (state, res) => {
      this.setState({ show_spinner: false });

      const { code = 100, reason = "預約失敗", data = {} } = res;

      if (state === false) {
        return this.setState({ message: "發生錯誤" });
      }

      if (code !== 200) {
        return this.setState({ message: reason });
      }

      const { booking: result = "預約失敗" } = data;

      // alert(result);
      //let modal = this.refs.modal
      //this.refs.modal.show({message:result})

      WModal.show(result, "", {
        callback: (title) => {
          this.props.history.replace("/bookinglist");
        },
      });
    });
  }
  render() {
    console.log("this.state", this.state);
    let canBookingToday = this.canBookingToday();
    const available_days = _.get(this, "state.available_days", []);
    const available_dates = _.map(new Array(28), (v, idx) =>
      moment().add(idx + (canBookingToday ? 0 : 1), "day")
    ).filter((m) => {
      // server 是1~7, moment是0~6
      let day = m.day() === 0 ? 7 : m.day();
      return available_days.indexOf(day) !== -1;
    });
    console.log("available_days", available_days);
    console.log("available_dates", available_dates);
    const item = this.state.item;
    return (
      <div className={styles.page_container}>
        <div className={[styles.padding_container, styles.view].join(" ")}>
          <div className={styles.title_area}>
            <div className={styles.page_title}>
              {this.state.item.name || "公設名稱"}
            </div>
            <div className={styles.points}>
              <div className={styles.point}>
                預約扣點：{this.state.item.point || 0}點
              </div>
              <div className={styles.point}>
                {item.cleaning_point_type === "C" ? "清潔費" : "清潔扣點"}：
                {this.state.item.cleaning_point || "0點"}
              </div>
            </div>
          </div>
          <div className={styles.content_area}>
            <from>
              <div className={styles.form_body}>
                <div className={styles.form_group}>
                  <div
                    className={styles.contorl_label}
                    style={{ color: this.state.error_date ? "red" : "inherit" }}
                  >
                    預約日期
                  </div>
                  <select
                    id="select-time"
                    className={styles.form_control}
                    value={this.state.date}
                    onChange={(e) => {
                      console.log("onChange", e.target.value);
                      this.changeDate(e.target.value);
                    }}
                  >
                    <option value={null}>請選擇預約日期</option>
                    {_.map(available_dates, (m) => {
                      return (
                        <option
                          key={m.format("YYYYMMDD")}
                          value={m.format("YYYYMMDD")}
                        >
                          {m.format("YYYY/MM/DD dddd")}
                        </option>
                      );
                    })}
                  </select>
                </div>

                {/* <div className={styles.form_group}>
                  <div className={styles.contorl_label} style={{ color: this.state.error_date ? 'red' : 'inherit' }}>預約日期</div>
                  <span>{moment(this.state.date, 'YYYYMMDD').format('YYYY/MM/DD')}</span>
                  <div>
                    <DatePicker inline
                      selected={moment(this.state.date, 'YYYYMMDD')}
                      onChange={(m) => {
                        console.log('kk',m)
                        if (!m) return
                        this.changeDate(m.format('YYYYMMDD'))
                      }}
                      minDate={moment().add(1, 'day')}
                      maxDate={moment().add(27, 'day')}
                      dateFormat="YYYYMMDD"
                      className={styles.form_control}
                      disabledKeyboardNavigation
                      onChangeRaw={e => {
                        e.target.value = this.state.date //.format('YYYY/MM/DD')
                      }}
                    />
                  </div>
                  
                </div> */}

                <Spin spinning={this.state.isFetchBookingTime === true}>
                  <div className={styles.form_group}>
                    <div
                      className={styles.contorl_label}
                      style={{
                        color: this.state.error_period ? "red" : "inherit",
                      }}
                    >
                      預約時段
                    </div>
                    <select
                      id="select-time"
                      className={styles.form_control}
                      onChange={(event) => this.changeTime(event)}
                    >
                      {this.state.available_time_message && (
                        <option>{this.state.available_time_message}</option>
                      )}

                      {this.state.available_time &&
                        this.state.available_time.map((item, idx) => (
                          <option value={idx} key={idx}>
                            {item.period0} | {item.note}
                          </option>
                        ))}
                    </select>
                  </div>

                  {/*
                  <div className={styles.form_group}>
                    <div className={styles.contorl_label}>使用基本扣點</div>
                    <input type="text" disabled="disabled" value={this.state.item.point} className={styles.form_control}/>
                  </div>
                  <div className={styles.form_group}>
                    <div className={styles.contorl_label}>清潔費</div>
                    <input type="text" disabled="disabled" value={this.state.item.cleaning_point}  className={styles.form_control}/>
                  </div>
                  */}

                  <hr />

                  <div className={styles.form_group}>
                    <div
                      className={styles.contorl_label}
                      style={{
                        color: this.state.error_person_count
                          ? "red"
                          : "inherit",
                      }}
                    >
                      預約人數
                    </div>
                    <input
                      type="text"
                      className={styles.form_control}
                      name="person_count"
                      placeholder="請輸入預約人數"
                      value={this.state.form.person_count}
                      onChange={(evt) => this.handleFormChange(evt)}
                    />
                  </div>
                  <div className={styles.form_group}>
                    <div
                      className={styles.contorl_label}
                      style={{
                        color: this.state.error_tel ? "red" : "inherit",
                      }}
                    >
                      聯絡電話
                    </div>
                    <input
                      type="text"
                      className={styles.form_control}
                      name="tel"
                      placeholder="請輸入聯絡電話"
                      value={this.state.form.tel}
                      onChange={(evt) => this.handleFormChange(evt)}
                    />
                  </div>
                  <div className={styles.form_group}>
                    <div
                      className={styles.contorl_label}
                      style={{
                        color: this.state.error_user_name ? "red" : "inherit",
                      }}
                    >
                      住戶姓名
                    </div>
                    <input
                      type="text"
                      className={styles.form_control}
                      name="user_name"
                      placeholder="請輸入住戶姓名"
                      value={this.state.form.user_name}
                      onChange={(evt) => this.handleFormChange(evt)}
                    />
                  </div>
                  <div className={styles.form_group}>
                    <div className={styles.contorl_label}>住戶備註</div>
                    <textarea
                      type="text"
                      placeholder=""
                      className={styles.form_control}
                      name="remark"
                      onChange={(evt) => this.handleFormChange(evt)}
                    />
                  </div>
                </Spin>
              </div>
            </from>
          </div>
          <div
            className={[
              styles.content_area,
              styles.btn_area,
              styles.sm_top,
            ].join(" ")}
          >
            <div className={styles.btn_area_col}>
              <WBtn
                title="取消"
                type="cancel"
                onClick={() => {
                  // if (UserInfo.houseid)
                  // {
                  //   WFirebase.logEvent('PublicUtilities',{'BookingCancel': UserInfo.houseid})
                  // }
                  // else
                  // {
                  //   UserInfo.pullData((user)=>{
                  //     WFirebase.logEvent('PublicUtilities',{'BookingCancel': UserInfo.houseid})
                  //   })
                  // }

                  this.props.history.goBack();
                }}
              />
            </div>
            <div className={styles.btn_area_col}>
              <WBtn
                title="我要預約"
                onClick={() => {
                  if (UserInfo.houseid) {
                    WFirebase.logEvent("PublicUtilities", {
                      BookingYes: UserInfo.houseid,
                    });
                  } else {
                    UserInfo.pullData((user) => {
                      WFirebase.logEvent("PublicUtilities", {
                        BookingYes: UserInfo.houseid,
                      });
                    });
                  }
                  this.submit();
                }}
              />
            </div>
          </div>
        </div>

        <WModal
          ref={"modal"}
          title="提醒"
          message="您確認要取消這筆預約嗎？"
          btns={["確認"]}
        />

        {this.state.message && <WMask title={this.state.message} />}
        {this.state.show_spinner && (
          <WMask>
            <WSpinner />
          </WMask>
        )}
      </div>
    );
  }
}

export default Booking;



// WEBPACK FOOTER //
// ./src/views/Facility/Booking.js